export default __webpack_public_path__ + "static/media/blue-hexagon.90a97ff1.svg";